<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-snackbar :value="notifications" multi-line vertical :timeout="-1" color="darken-4" bottom right elevation="24">
        <p>Would you like to receive notifications</p>
        <template v-slot:action="{ attrs }">
          <v-btn color="green" outlined v-bind="attrs" @click="turnonnotif" class="ring-bell" active :loading="loading" title="Turn on notifications">
            <v-icon left>mdi-bell-ring</v-icon>
            Turn On
          </v-btn>
          <v-btn color="" text v-bind="attrs" @click="notifications = false" class="ml-5" title="Decline">
            {{ decline }}
          </v-btn>
        </template>
      </v-snackbar>
      <v-snackbar :timeout="10000" v-model="snackbar" color="primary" absolute left rounded="" top multi-line>
        <span v-html="message"></span>
        <template v-slot:action="{ attrs }">
          <v-btn color="red" text v-bind="attrs" @click="snackbar = false" title="Close">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </transition>
</template>

<script>
  export default {
    name: 'PermissionForNotifications',
    props: [],
    data () {
      return {
        notifications: false,
        loading: false,
        snackbar: false,
        message: '',
        decline: 'Decline',
        supressMessage: false
      }
    },
    methods: {
      turnonnotif () {
        this.loading = true
        this.decline = 'Close'
        if (!('Notification' in window)) {
          this.message = 'Your browser doesn\'t support Notifications'
          this.snackbar = true
          return
        }
        if (Notification.permission === 'denied') {
          this.message = 'You have explicitly denied notifications for this app. <br>Please reset notifications settings for this url ' + window.location.origin
          this.snackbar = true
        }
        window.dispatchEvent(new CustomEvent('notifyme'));
      },
      checkNotif () {
        if ('Notification' in window) {
          if (Notification.permission != 'granted') {
            this.notifications = true
          }
          if (Notification.permission === 'granted') {
            this.supressMessage = true
          }
        }
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.checkNotif()
      })
      window.addEventListener('notifyon', function () {
        this.loading = false
        this.notifications = false
        this.message = 'Successfully subscribed to Push notifications'
        this.snackbar = !this.supressMessage
      }.bind(this))
    },
  }
</script>
